// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"59e72b6d","455":"3a0feb1c","977":"756f6082"}[chunkId] + ".chunk.js";
};